import React from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";
import { useHistory } from "react-router-dom";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Embed from "react-embed";
// import InstagramEmbed from "react-instagram-embed";
// import RedirectImage from "~/Components/Global/RedirectImage";
import { useUser } from "~/Context/userContext";

import "./Tile.less";
import "./TileArchive.less";

function createMarkup(otd_text) {
  return { __html: otd_text };
}

// Instagram
// READ: https://developers.facebook.com/apps/619124338182144/oembed/settings/

//in your component

const defaultImg = `//dreamchimney.com/tracks/track_images/12208.jpg`;

// Default image for src error handling
function addDefaultSrc(ev) {
  ev.target.src = defaultImg;
}

const TileImageLink = ({ slug, img_url }) => (
  <Link to={`/${slug}`}>
    <img className="img-responsive" alt="" onError={addDefaultSrc} src={`${img_url}`} />
  </Link>
);

const getYouTubeIdFromUrl = (url) => {
  var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  var match = url.match(regExp);
  return match && match[7].length === 11 ? match[7] : false;
};

const Tile = (props) => {
  let history = useHistory();
  const { state: userState } = useUser();

  const {
    archive = false,
    preview = false,
    otd: { id, date, otd_title, slug, otd_text, img_url, link_url, tags, chim_dir, chim_full_name, cmt_count },
  } = props;

  const isArchive = archive;

  const linkUrlArray = (link_url && link_url.split("/")) || [];

  const isInstagram = linkUrlArray[2] && linkUrlArray[2].includes(`instagram`);
  const isTwitter = linkUrlArray[2] && (linkUrlArray[2].includes(`twitter`) || linkUrlArray[2].includes(`x.com`));
  const isVimeo = linkUrlArray[2] && linkUrlArray[2].includes(`vimeo`);
  const isYouTube = linkUrlArray[2] && (linkUrlArray[2].includes(`youtu.be`) || linkUrlArray[2].includes(`youtube`));

  let isEmbed = linkUrlArray[2] && (isTwitter || isYouTube || isVimeo);

  // force x links to twitter so embed react library will work
  let linkUrl = link_url && link_url.replace('x.com', 'twitter.com');

  // odd case for tweets
  if ((isTwitter || isInstagram || isYouTube) && isArchive) isEmbed = false;

  let imgUrl = img_url && img_url.startsWith("http") ? img_url : img_url ? `//dreamchimney.com/${img_url}` : null;

  // let imgUrl = img_url ? `//dreamchimney.com/${img_url}` : null;

  if (img_url && isTwitter) imgUrl = img_url;

  // youtube short https://youtube.com/shorts/bBcX4bUjqB4?feature=share
  // instead use this https://youtu.be/bBcX4bUjqB4

  if (isYouTube) {
    if (linkUrl.includes("shorts/")) {
      linkUrl = linkUrl.replace("shorts/", "").replace("https://youtube.com/", "https://youtu.be/");
    }
  }
  if (isYouTube && isArchive) {
    const ytId = getYouTubeIdFromUrl(linkUrl);
    imgUrl = `http://i3.ytimg.com/vi/${ytId}/hqdefault.jpg`;
  }

  let instagramLinkUrl = '';
  let igId = '';
  if (isInstagram) {
    igId = linkUrlArray[4] || null;
    // IG posts with long urls over 11 ? are private, cant show preview
    if (igId && igId.length < 20) {
      // linkUrl = igId && `https://instagr.am/p/${igId}/`;
      instagramLinkUrl = igId && `https://instagr.am/p/${igId}/`;
      // imgUrl = `https://www.instagram.com/p/${igId}/media/?size=m`; // not sure this is working ?
      imgUrl = `https://i.snipboard.io/QSXU2Y.jpg`;
    }
  }

  const editButton = () => {
    history.push(`/edit/${id}/${slug}`);
  };

  return (
    <div className={classNames({ TileWrapper: true, TileArchive: isArchive })}>
      <div className="tileTitle">
        {isArchive && <Link to={`/${slug}`}>"{otd_title}" of the Day</Link>}
        {!isArchive && <>"{otd_title}" of the Day</>}
      </div>

      <div className="tileMiddle">
        {/* Text Description */}
        {otd_text && <div dangerouslySetInnerHTML={createMarkup(otd_text)} className="description" />}

        {/* YouTube */}
        {isEmbed && (
          <Row noGutters>
            <Col style={{ textAlign: "center" }} sm={12}>
              <div className={classNames({ embedResponsive: isYouTube })}>
                <Embed url={linkUrl} />
              </div>
            </Col>
          </Row>
        )}
        {/* {isInstagram && !isArchive && (
          <Row noGutters>
            <Col style={{ textAlign: "center" }} xs={12} sm={{ span: 8, offset: 2 }}>
              <div className={classNames({ embedResponsive: isYouTube })}>
                <div style={{ textAlign: "center", margin: '0 auto' }}>
                  <blockquote class="instagram-media" data-instgrm-captioned data-instgrm-permalink={`https://www.instagram.com/p/${igId}/?utm_source=ig_embed&amp;utm_campaign=loading`} data-instgrm-version="14"></blockquote>
                </div>
              </div>
            </Col>
          </Row>
        )}
 */}

        {/* OTD Image */}
        {imgUrl && (
          <div className="contentImage">
            {isArchive && !isInstagram && <TileImageLink slug={slug} img_url={imgUrl} />}
            {isArchive && isInstagram && <TileImageLink slug={slug} img_url={`https://i.snipboard.io/QSXU2Y.jpg`} />}
            {!isArchive && !isTwitter && !isInstagram && <img className="img-responsive" src={imgUrl} />}
          </div>
        )}

        {/* OTD Link */}
        {link_url && !isArchive && link_url !== "http://" && (
          <div className="contentLink">
            <a href={link_url} target="_blank" rel="noopener noreferrer">
              {link_url}
            </a>
          </div>
        )}

        <div className="footer">
          {tags && (
            <div className="fileUnderTag tagSm">
              File Under:{" "}
              {tags.map((tag) => (
                <span key={tag.tag_id}>
                  <Link to={`/tag/${tag.tag_slug}`}>{tag.tag}</Link>
                </span>
              ))}
            </div>
          )}

          <div className="credits">
            <Row noGutters>
              <Col md={8}>
                <div className="author">
                  From: <Link to={`/profile/${chim_dir}`}>{chim_full_name} Chimney</Link>
                </div>
              </Col>
              <Col md={4} className="text-right">
                {isArchive && (
                  <div className="comments">
                    {cmt_count} comment{cmt_count !== "1" ? `s` : null}
                  </div>
                )}
                {!isArchive && !preview && (chim_dir === userState.user.dir || userState.user.dir === "ryan") && (
                  <div style={{ marginTop: "10px" }}>
                    <Button size="sm" onClick={(e) => editButton(e)}>
                      Edit
                    </Button>
                  </div>
                )}
              </Col>
            </Row>
          </div>
        </div>
      </div>
      {props.children}
    </div>
  );
};

Tile.defaultProps = {
  archive: false,
};

export default Tile;
